import { ChunkSnippet } from "@/src/graphql/generated";
import { AppState } from "..";

function snippets(state: AppState) {
  return state.dealSearch.snippets;
}

function chunkSnippet(
  state: AppState,
  chunkId: string,
  searchTerm: string,
): Partial<ChunkSnippet> | undefined {
  if (state.dealSearch.snippets[`${searchTerm}-${chunkId}`]) {
    return state.dealSearch.snippets[`${searchTerm}-${chunkId}`];
  }

  return undefined;
}

export const dealSearchSelectors = {
  chunkSnippet,
  snippets,
};
